const getPathQuery = function (url: string) {
  let re = {
    path: '',
    query: {}
  }
  if (url) {
    let path = '', query = {};
    if (url.indexOf('?') > -1) {
      path = url.substring(0, url.indexOf('?'))
      let queryStr = url.substring(url.indexOf('?') + 1)
      let queryStrArr = []
      if (queryStr.indexOf('&') > -1) {
        queryStrArr = queryStr.split('&')
      } else {
        queryStrArr = [queryStr]
      }
      queryStrArr.forEach(item => {
        let arr = item.split('=')
        query[arr[0]] = arr[1]
      })
    } else {
      path = url
    }
    re.path = path;
    re.query = query
  }
  return re
}
export default {
  getPathQuery
}